import { render } from "./UnpaidBillsWidget.vue?vue&type=template&id=46a997b6"
import script from "./UnpaidBillsWidget.vue?vue&type=script&lang=js"
export * from "./UnpaidBillsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__